import { render } from "./BaseBackButton.vue?vue&type=template&id=651e0fe4&scoped=true"
import script from "./BaseBackButton.vue?vue&type=script&lang=js"
export * from "./BaseBackButton.vue?vue&type=script&lang=js"

import "./BaseBackButton.vue?vue&type=style&index=0&id=651e0fe4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651e0fe4"]])

export default __exports__